
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(48.537 -141.463)"}},[_c('circle',{attrs:{"cx":"14","cy":"14","r":"14","fill":"#d80027","data-name":"Ellipse 2","transform":"translate(-48.537 141.463)"}}),_c('g',{attrs:{"fill":"#ffda44","data-name":"Group 21"}},[_c('path',{attrs:{"d":"M-41.085 149.802l1.249 3.842h4.04l-3.266 2.378 1.249 3.842-3.271-2.373-3.271 2.373 1.253-3.842-3.271-2.378h4.04z","data-name":"Path 25"}}),_c('path',{attrs:{"d":"M-31.856 163.4l-.955-1.175-1.412.548.819-1.271-.955-1.181 1.463.39.825-1.271.079 1.514 1.469.39-1.418.542z","data-name":"Path 26"}}),_c('path',{attrs:{"d":"M-29.955 159.954l.452-1.446-1.237-.876 1.514-.023.446-1.446.492 1.435 1.514-.017-1.215.9.486 1.435-1.237-.876z","data-name":"Path 27"}}),_c('path',{attrs:{"d":"M-27.396 151.615l-.667 1.362 1.085 1.056-1.5-.215-.667 1.356-.26-1.492-1.5-.215 1.345-.706-.26-1.5 1.085 1.056z","data-name":"Path 28"}}),_c('path',{attrs:{"d":"M-31.814 147.491l-.113 1.508 1.407.571-1.475.362-.107 1.514-.8-1.288-1.475.362.977-1.158-.8-1.282 1.407.571z","data-name":"Path 29"}})])])])
          )
        }
      }
    